import { render, staticRenderFns } from "./DeleteAppointments.vue?vue&type=template&id=3ce50298&scoped=true&"
import script from "./DeleteAppointments.vue?vue&type=script&lang=js&"
export * from "./DeleteAppointments.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAppointments.vue?vue&type=style&index=0&id=3ce50298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce50298",
  null
  
)

export default component.exports